<template>
  <div id="mapa-financeiro">
    <div class="w3-row-padding row-mapa-financeiro">
      <div v-cloak class="w3-panel w3-theme w3-card" v-if="processando">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>

      <div class="card-pedido-bloqueado" v-else v-cloak>
        <div>
        <hr>
          <div class="card-item w3-container"> 
            <div class="col s12 ">
              <div class="w3-col m8 s12 w3-left">
                <label>Comprador: </label>
                <strong>{{compra.nome_comprador}} </strong>
              </div>
              
              <div class="w3-col m8 s12 w3-left">
                <label>Data faturamento: </label>
                <strong>{{compra.data_faturamento}}  </strong>
              </div>
              
              <div class="w3-col m8 s12 w3-left">
                <label>Previsão de entrega: </label>
                <strong>{{compra.previsao_entrega}}  </strong>
              </div>
              
              <div class="w3-col m8 s12 w3-left">
                <label>Quantidade de itens: </label>
                <strong>{{compra.itens.length}}  </strong>
              </div>

              <div 
                  v-for="(prazo, prazo_index) in compra.prazos"
                  key="prazo_index"
                  class="w3-col w3-small" 
                >
                <div class="w3-col  w3-margin-top w3-btn w3-border w3-border-gray"  style="margin-right: 3px;">
                  <label style="text-align:center">Prazo: </label>
                  <strong style="text-align:center">{{prazo.prazo}}</strong>
                  <span> | </span>
                  <label style="text-align:center">Vencimento: </label>
                  <strong style="text-align:center">{{prazo.vencimento}}</strong>
                </div>
                  
              </div>
              

              <div class="w3-col m12 s12" style=" overflow:auto; padding: 10px">
                <button
                  class="btn-liberar w3-button w3-theme"
                  v-if="autorizacao_deletar == 'S' || gerente == 'S'"
                  @click.stop="recusarCompra()"
                  style="width: 270px; margin-top:5px;">
                  Cancelar pedido
                </button>

                <button
                  class="btn-liberar w3-button w3-theme "
                  v-if="!mostrar_itens"
                  @click.stop="mostrarItens(true)"
                  style="width: 270px; margin-top:5px; float: right">
                  Itens
                  <strong>+</strong>
                </button>

                <button
                  class="btn-liberar w3-button w3-theme "
                  v-if="mostrar_itens"
                  @click.stop="mostrarItens(false)"
                  style="width: 270px; margin-top:5px; float: right">
                  Itens
                  <strong>-</strong>
                </button>
              </div>
            </div>

          </div>
          
          <div class="col s12 " v-if="mostrar_itens">
            <div 
              class="card-item w3-container w3-small" 
              v-for="(item, index) in compra.itens" 
              :key="index">

              <div class="w3-col 12" >
                <label  style="font-weight: inherit; font-style: italic;">Item {{index + 1}}</label>
                <strong style="color:green; margin-left: calc(100% - 120px);">R$ {{item.total_liquido}}</strong>
              </div>
              

              <div class="w3-col s12" >
                <strong class="w3-text-theme"><i class="fas fa-box"></i>&nbsp;{{item.produto_id}} - {{item.nome_produto}} - {{item.unidade_compra}}</strong>
              </div>

              <div class="w3-col s12" v-if="item.preco != '0'">
                <label>Preço unitário: </label>
                <strong>R$ {{item.preco}}</strong>
              </div>

              <div class="w3-col s12" v-if="item.quantidade != '0'">
                <label>Quantidade: </label>
                <strong>{{item.quantidade}}</strong>
              </div>  

              <div class="w3-col s12" v-if="item.valor_desconto != '0,0000'">
                <label>Valor desconto: </label>
                <strong>R$ {{item.valor_desconto}}</strong>
              </div> 

              <div class="w3-col s12" v-if="item.perc_desconto != '0,0000'">
                <label>Desconto: </label>
                <strong>{{item.perc_desconto}}%</strong>
              </div>

              <div class="w3-col s12" v-if="item.valor_frete != '0'">
                <label>Valor frete: </label>
                <strong>R$ {{item.valor_frete}}</strong>
              </div>

              <div class="w3-col s12" v-if="item.valor_ipi_outras_despesas != '0'">
                <label>Outras despesas: </label>
                <strong>R$ {{item.valor_ipi_outras_despesas}}</strong>
              </div>

              <div class="w3-col s12" v-if="item.valor_ipi != '0'">
                <label>Valor IPI: </label>
                <strong>R$ {{item.valor_ipi}}</strong> 
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  import toastr from 'toastr'
  import RCompraBuscarCompraDetalhada from '@/components/Rest/RCompra/RCompraBuscarCompraDetalhada.js'
  import RCompraLiberarCompra from '@/components/Rest/RCompra/RCompraLiberarCompra.js'
  import RCompraCancelarCompra from '@/components/Rest/RCompra/RCompraCancelarCompra.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  
  export default {
    name: 'ModalComprasPendentes',

    props: ['compra_id', 'autorizacao_deletar', 'gerente'],

    mixins:[formatarValorMixin],

    data() {
      return {
        mostrar_itens: false,
        processando: true,
        compra: {}
      }
    },

    mounted() {
      this.buscarCompra()
    },

    methods: {
      mostrarItens(boolean) {
        this.mostrar_itens = boolean;
      },

      atualizar() {
        this.$parent.buscarComprasEmAberto()
      },

      async buscarCompra() { 
        try {
          let parametros = {
            compra_id: this.compra_id
          }

          let retorno = await RCompraBuscarCompraDetalhada.buscarCompraDetalhada(
            this.axios, 
            parametros
          );
          
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          this.compra = JSON.parse(JSON.stringify(retorno.dados));
          this.processando = false;
        }
        catch (error) {
          this.processando = false;
          toastr.error(error.message);
          
        }
      },

      recusarCompra() {
        const self = this;
        swal(
          {
            title: 'Motivo da recusa do pedido',
            className: 'modalLiberarCompra',
            buttons: ['Cancelar', 'Recusar pedido'],
            showCloseButton: true,
            text: 'Motivo da recusa do pedido',
            focusConfirm: false,
            content: {
              element: 'textarea',
              attributes: {
                rows: 3,
                class: 'w3-input w3-block w3-border',
              }
            }
          }
        )
        .then(
          async (isConfirm) => {
            let textarea = document.querySelector('.modalLiberarCompra .swal-content__textarea').value;
            if (!isConfirm) {
              return;
            }

            if (textarea === '') {
              toastr.error('O motivo do cancelamento da compra não pode ser vazio');
              return;
            }

            try {
              let parametros = {
                compra_id: self.compra_id,
                motivo_cancelamento: textarea
              }

              let retorno = await RCompraCancelarCompra.cancelarCompra(this.axios, parametros);
              if (retorno.houve_erro != 'N') {
                throw new Error(retorno.mensagem);
              }
              
              toastr.success('Compra recusada com sucesso.');
              self.$emit('reprocessarCompras');
            }
            catch (error) {
              toastr.error(error.message);
              return;
            }
          }
        );
      },
    }
  }
</script>

<style scoped>
  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }
  
  .dados_mapa {
    margin-top: 20px;
  }

  .texto-responsivo {
    word-break: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;
  }

  .w3-modal-content {
    margin: 0 !important;
    transform: translateX(50%);
  }

  .row-mapa-financeiro{
    padding: 0 
  }

  .divTabelaBloqueios {
    width: 100%;
    float: left;
  }

  .chip-vencimento {
    border-radius: 25px;
    cursor: pointer;
    font-size: .9em;
    padding: 10px 15px;
    text-decoration: underline;
  }

  .card-portador {
    border-left: 3px solid #9c1d1c;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 ;
    padding: 5px 10px;
  }

  .card-portador .w3-text-theme {
    text-transform: uppercase;
  }

  @media(max-width: 992px) {
    .dados_mapa.w3-row-padding {
      padding: 0 !important
    }
    
    .box-contas {
      margin-bottom: 20px
    }

    .box-contas:last-child {
      margin-bottom: 0;
    }
  }

  @media(max-width: 500px) {
    .card-pedido-bloqueado .w3-row-padding {
      padding: 0
    }
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    background: white
  }

  .btn-liberar {
    width: auto !important;
  }

  .w3-right {
    float: none !important;
    padding-left: 10px;
  }

  .itens-mobile-info {
    float: right
  }

  .td-itens {
    text-align: center
  }

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ModalComprasPendentes.vue